<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
  <dialog-header
    [label]="userPerm == 0 ? ('SETTINGS.TRACK_SETTINGS' | translate) : ('TRACKS.POLYGON_SETTINGS' | translate)"
    [dialogRef]='dialogRef' [object]='this'></dialog-header>

  <mat-card class="display-settings">
    <div *ngIf="!userPerm">
      <!-- History -->
      <mat-selection-list dense>
        <mat-list-option class="selection-list-option" checkboxPosition="before"
          *ngFor="let trackElem of trackElements; index as i" [selected]="trackElementsOn[i]"
          (click)="onTrackElemBtnClick(i)">{{trackElem}}</mat-list-option>
      </mat-selection-list>
      <div class="slider-with-label" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
        <span>{{'TRACKS.TRAIL' | translate}}&nbsp;&nbsp;{{'TRACKS.LENGTH' | translate}}</span>
        <mat-slider fxFlex="grow" thumbLabel tickInterval="{{trackTrailMaxLength() / 10}}" step="1" min="0"
          max="{{trackTrailMaxLength()}}" [value]="trackTrailLength" (change)="onTrackTrailSliderChanged($event)">
        </mat-slider>
      </div>
      <div class="slider-with-label" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
        <span>Life&nbsp;Time</span>
        <mat-slider fxFlex="grow" thumbLabel tickInterval="{{trackLifeTimeMaxTime() / 10}}" step="1" min="0"
          max="{{trackLifeTimeMaxTime()}}" [value]="trackLifeTime" (change)="onTrackLifeTimeSliderChanged($event)">
        </mat-slider>
      </div>

      <mat-divider></mat-divider>
      <!-- System Tracks -->
      <div class="selection-list-title">{{'TRACKS.TRACK_DISPLAY_SETTINGS' | translate}}</div>
      <mat-selection-list dense style="padding-bottom: 10px">
        <mat-list-option *ngFor="let trackElem of sysTrackElements.slice(0, 4); index as i"
          [class]="trackElem ? 'selection-list-option' : 'selection-list-hidden-option'" checkboxPosition="before"
          [selected]="sysTrackElementsOn[i]" (click)="onSysTrackElemBtnClick(i)">
          {{trackElem}}
        </mat-list-option>
      </mat-selection-list>
      <mat-divider></mat-divider>
    </div>
    <!-- TBM Polygon Ip -->
    <div class="selection-list-title">{{'CONSTS.SYS_TRACK_DISPLAY_ELEMENT_IP_TITLE' | translate}}</div>
    <mat-selection-list dense>
      <mat-list-option [class]="'selection-list-option'" checkboxPosition="before" [selected]="sysTrackElementsOn[4]"
        (click)="onSysTrackElemBtnClick(4)">
        {{sysTrackElements[4]}}
      </mat-list-option>
    </mat-selection-list>

    <div *ngIf="!userPerm" #ipColorButton class="slider-with-label" fxLayout="row">
      <button mat-icon-button [matTooltip]="'MAP.COLOR' | translate" matTooltipPosition="below"
        matTooltipShowDelay="2000" [disabled]="isColorPickerActive()" (click)="onIpColorClick()">
        <mat-icon class="color-picker-icon" [ngStyle]="{'background': colorPickerIconColorIp()}">color_lens</mat-icon>
        {{'CONSTS.SYS_TRACK_DISPLAY_ELEMENT_IP_COLOR' | translate}}
      </button>
    </div>

    <div *ngIf="!userPerm" #ipColorButtonSmt class="slider-with-label" fxLayout="row">
      <button mat-icon-button [matTooltip]="'MAP.COLOR' | translate" matTooltipPosition="below"
        matTooltipShowDelay="2000" [disabled]="isColorPickerActive()" (click)="onIpColorClickSmt()">
        <mat-icon class="color-picker-icon" [ngStyle]="{'background': colorPickerIconColorIpSmt()}">color_lens
        </mat-icon>
        {{'CONSTS.SYS_TRACK_DISPLAY_ELEMENT_IP_COLOR_SMT' | translate}}
      </button>
    </div>

    <div class="slider-with-label" fxLayout="row" fxLayoutAlign="left center">
      <span> {{'CONSTS.SYS_TRACK_DISPLAY_ELEMENT_IP_OPACITY' | translate}} </span>
      <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
        min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="IpFillBrightness"
        (change)="ipBrightnessSliderChanged($event)">
      </mat-slider>
    </div>

    <mat-divider></mat-divider>

    <!-- Threat Polygon -->
    <div class="selection-list-title">{{'TRACKS.THREAD_POLYGON_SETTINGS' | translate}}</div>
    <mat-selection-list dense>
      <mat-list-option [class]="'selection-list-option'" checkboxPosition="before" [selected]="sysTrackElementsOn[5]"
        (click)="onSysTrackElemBtnClick(5)">
        {{sysTrackElements[5]}}
      </mat-list-option>
    </mat-selection-list>

    <div *ngIf="!userPerm" #tpColorButton class="slider-with-label" fxLayout="row">
      <button mat-icon-button [matTooltip]="'MAP.COLOR' | translate" matTooltipPosition="below"
        matTooltipShowDelay="2000" [disabled]="isColorPickerActive()" (click)="onTpColorClick()">
        <mat-icon class="color-picker-icon" [ngStyle]="{'background': colorPickerIconColorTp()}">color_lens</mat-icon>
        {{'TRACKS.THREAD_POLYGON_COLOR' | translate}}
      </button>
    </div>

    <div *ngIf="!userPerm" #tpColorButtonSmt class="slider-with-label" fxLayout="row">
      <button mat-icon-button [matTooltip]="'MAP.COLOR' | translate" matTooltipPosition="below"
        matTooltipShowDelay="2000" [disabled]="isColorPickerActive()" (click)="onTpColorClickSmt()">
        <mat-icon class="color-picker-icon" [ngStyle]="{'background': colorPickerIconColorTpSmt()}">color_lens
        </mat-icon>
        {{'TRACKS.THREAD_POLYGON_COLOR_SMT' | translate}}
      </button>
    </div>

    <div class="slider-with-label" fxLayout="row" fxLayoutAlign="left center">
      <span>{{'TRACKS.THREAD_POLYGON_OPACITY' | translate}}</span>
      <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
        min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="IpFillBrightness"
        (change)="tpBrightnessSliderChanged($event)">
      </mat-slider>
    </div>

    <!-- this section is color and size control of text for user -->
    <div *ngIf="userPerm">
      <mat-divider></mat-divider>

      <mat-selection-list dense>
        <mat-list-option [class]="'selection-list-option'" checkboxPosition="before" [selected]="trackTextToggler"
          (click)="onTrackTextToggler()">
          {{'TRACKS.POLYGON_TEXT' | translate}}
        </mat-list-option>
      </mat-selection-list>

      <div #trackTextColorButton class="slider-with-label" fxLayout="row">
        <button mat-icon-button [matTooltip]="'MAP.COLOR' | translate" matTooltipPosition="below"
          matTooltipShowDelay="2000" [disabled]="isColorPickerActive()" (click)="onTextColorClick()">
          <mat-icon class="color-picker-icon" [ngStyle]="{'background': colorPickerIconTextColor()}">color_lens
          </mat-icon>
          {{'TRACKS.POLYGON_TEXT_COLOR' | translate}}
        </button>
      </div>

      <div class="slider-with-label" fxLayout="row" fxLayoutAlign="left center">
        <span>{{'MAP.TEXTSIZE' | translate}}</span>
        <mat-slider class="opacity-slider" thumbLabel tickInterval=1 step=0.1 min=0.5 max=2.5 [value]="textSize"
          (change)="trackTextSizeSliderChanged($event)">
        </mat-slider>
      </div>
    </div>

  </mat-card>
</div>